import React from "react";
import { motion } from "framer-motion";
import SectionHeading from "./SectionHeading";
import Reveal from "./Reveal";
import { experienceMeta } from "../data/content";
import { useLanguage } from "../context/LanguageContext";

export default function Experience() {
    const { t } = useLanguage();

    return (
        <section id="experience" className="section">
            <div className="section__inner">
                <SectionHeading eyebrow={t.experience.eyebrow} title={t.experience.title} />

                <div className="timeline">
                    <motion.div
                        className="timeline__line"
                        initial={{ scaleY: 0 }}
                        whileInView={{ scaleY: 1 }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ duration: 1, ease: [0.22, 0.9, 0.32, 1] }}
                    />

                    {experienceMeta.map((item, i) => {
                        const text = t.experience.items[item.id];
                        return (
                            <Reveal key={item.id} delay={i * 0.08} className="timeline__item">
                                <span className="timeline__dot" />
                                <div className="timeline__card">
                                    <div className="timeline__card-head">
                                        <h3>{text.role}</h3>
                                        {item.current && <span className="badge badge--live">{t.experience.current}</span>}
                                    </div>
                                    <p className="timeline__company">
                                        {text.company} — {text.place}
                                    </p>
                                    <p className="timeline__date">{item.date}</p>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
